<template>
    <div class="teq-container">

        <div class="title">
            <h1>{{ title }}</h1>    
        </div>
        
        <div class="content">
            <div class="label">
                <h3>{{ label }}</h3>
            </div>
            <div class="filters-container">
                <services-select
                    placeholder-select="services" 
                    :options-select="this.servicesNames"
                    @serviceName="getCountries">
                </services-select>
                <countries-select
                    v-if="this.paysNames.length > 0" 
                    :placeholder-select="placeholderCountries" 
                    :options-select="this.paysNames"
                    @countryName="getTexts"
                    :serviceName="service.nom_du_service">
                </countries-select>
                <div v-if="serviceQtext || countryQtexte" v-html="this.firstText" class="text first-text"></div>
                <div v-if="serviceQtext || countryQtexte" v-html="this.secondText" class="text second-text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import ServicesSelect from './ServicesSelect'
import CountriesSelect from './CountriesSelect'
import gsap from 'gsap'

    export default {
        components: {
            ServicesSelect,
            CountriesSelect,
        },
        data() {
            return {
                data: '',
                servicesNames: [],
                service: {},
                paysNames: [],
                firstText: '',
                secondText: '',
                countryQtexte: false,
                serviceQtext: false,
            }
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            ajaxUrl: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            placeholderCountries: {
                type: String,
                required: true, 
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            async getData() {
                let rep = await fetch(this.ajaxUrl);
                const data = await rep.json();
                this.data = data.data;

                /**
                 * Get all the Service name to push them inside a new Array
                 * who will be pass has props props for the Service Select
                 */
                this.data.services.map(data => {
                    this.servicesNames.push(data.nom_du_service);
                });
            },
            /**
             * Get all the Countries related to the specified service
             * @param {String} serviceName The name of the selected service
             */
            getCountries(serviceName) {
                // Always empty the Array before to push new Countries
                this.paysNames = [];

                // Get the good object by filtering by service name
                const serviceFiltered = this.data.services.filter(service => {
                    return service.nom_du_service === serviceName
                });
                const service = serviceFiltered[0]

                // Push each new countries inside our data
                if(service.qpays) {
                    service.pays.map(country => {
                        this.paysNames.push(country.nom_du_pays);
                    });
                    this.paysNames.sort()
                }

                // Save the actual service
                this.service = service;

                // Check if we need to display the form or not using the Boolean "qcontact"
                this.displayForm(service.qcontact);

                // Check with the boolean "qtexte" if we have a texte to display or not
                this.serviceQtext = service.qtexte
                if(this.serviceQtext) {
                    service.textes[0].texte ? this.firstText = service.textes[0].texte : null;
                    service.textes[1].texte ? this.secondText = service.textes[1].texte : null;
                    this.textsAnimation();
                }else {
                    this.firstText = '';
                    this.secondText = ''; 
                }
            },
            /**
             * Get all the texts form the selected country
             * @param {String} countryName The name of the selected country
             */
            getTexts(countryName) {
                if(countryName){
                    const countriesFiltered = this.service.pays.filter(country => {
                        return country.nom_du_pays === countryName 
                    });
                    const country = countriesFiltered[0]
                    
                    // Check if we need to display the form or not using the Boolean "qcontact"
                    this.displayForm(country.qcontact);

                    // Check with the Boolean "qtexte" if we have a texte to display or not
                    this.countryQtexte = country.qtexte
                    if(this.countryQtexte) {
                        country.textes[0].texte ? this.firstText = country.textes[0].texte : null;
                        country.textes[1].texte ? this.secondText = country.textes[1].texte : null;
                        this.textsAnimation();
                    }else {
                        this.firstText = '';
                        this.secondText = ''; 
                    }
                }
            },
            /**
             * Check for display or not the form
             * @param {Boolean} qContact The Boolean value for check if the user want to display the form or not
             */
            displayForm(qContact) {
                const form = document.querySelector('.nf-form-content');
                qContact ? form.classList.add('active') : form.classList.remove('active');
                this.formAnimation();
            },
            /**
             * Appearance animation for texts
             */
            textsAnimation(){
                gsap.fromTo('.text',{ opacity: 0 },{
                    alpha: 1,
                    delay: 0.3,
                    duration: 0.4,
                    ease: "power1.in"
                });
            },
            /**
             * Appearance animation for the form
             */
            formAnimation() {
                gsap.fromTo('.nf-form-content',{ opacity: 0 },{
                    alpha: 1,
                    delay: 0.3,
                    duration: 0.4,
                    ease: "power1.in"
                });
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>